"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOperation = exports.performTransform = exports.validateTransform = exports.baseFieldsToFinleyArrayJsonSchema = exports.mapBaseFieldsTemplateToFinleySubType = exports.FINANCIAL_STATEMENT_BASE_FIELDS = void 0;
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const errorUtils_1 = require("./errorUtils");
const helpers_1 = require("./helpers");
const sanitizeTransform = __importStar(require("./sanitize-transform"));
exports.FINANCIAL_STATEMENT_BASE_FIELDS = [
    { field: 'ledgerName', type: 'string' },
    { field: 'value', type: 'float' },
    { field: 'section', type: 'string' },
    { field: 'groups', type: 'optionalString' },
];
const mapBaseFieldsTemplateToFinleySubType = (baseFieldsTemplate) => {
    if (!baseFieldsTemplate) {
        return 'generalTransform';
    }
    switch (baseFieldsTemplate) {
        case 'balanceSheet':
        case 'incomeStatement':
            return 'financialStatement';
        default:
            throw (0, common_1.finleyAssertUnreachable)(baseFieldsTemplate);
    }
};
exports.mapBaseFieldsTemplateToFinleySubType = mapBaseFieldsTemplateToFinleySubType;
const mapConfigToSchema = ({ config, baseFieldsTemplate, }) => {
    const common = {};
    if (config.description) {
        common.description = config.description;
    }
    switch (config.type) {
        // ----- Strings -----
        case 'string': {
            // if using baseFieldsTemplate, add strictness to the jsonschema for allowed values
            switch (baseFieldsTemplate) {
                case 'balanceSheet':
                    if (config.field === 'section') {
                        common.enum = finley_types_1.FinStatementV2.BalanceSheetSectionSchema.options;
                    }
                    break;
                case 'incomeStatement':
                    if (config.field === 'section') {
                        common.enum = finley_types_1.FinStatementV2.IncomeStatementSectionSchema.options;
                    }
                    break;
                default:
                    break;
            }
            return { type: 'string', ...common };
        }
        case 'optionalString':
            return { type: ['string', 'null'], ...common };
        // ----- Booleans -----
        case 'boolean':
            return { type: 'boolean', ...common };
        case 'optionalBoolean':
            return { type: ['boolean', 'null'], ...common };
        // ----- Dates -----
        case 'date':
            return { type: 'string', format: 'date', ...common };
        case 'optionalDate':
            return {
                type: ['string', 'null'],
                format: 'date', // INVESTIGATE DATE PRIOR TO MERGE
                ...common,
            };
        // ----- DateTimes -----
        case 'dateTime':
            return { type: 'string', format: 'date-time', ...common };
        case 'optionalDateTime':
            return {
                type: ['string', 'null'], // INVESTIGATE DATE PRIOR TO MERGE
                format: 'date-time',
                ...common,
            };
        // ----- Numbers (float/percentage/currency -> number) -----
        case 'float':
        case 'percentage':
        case 'currency':
            return { type: 'number', ...common };
        case 'optionalFloat':
        case 'optionalPercentage':
        case 'optionalCurrency':
            return { type: ['number', 'null'], ...common };
        // ----- Integers -----
        case 'integer':
            return { type: 'integer', ...common };
        case 'optionalInteger':
            return { type: ['integer', 'null'], ...common };
        default:
            return (0, common_1.finleyAssertUnreachable)(config);
    }
};
const baseFieldsToFinleyArrayJsonSchema = ({ fields, baseFieldsTemplate, }) => {
    // map of each csv fieldName: jsonSchema definition
    const properties = {};
    const required = [];
    for (const config of fields) {
        const field = config.field;
        const propSchema = mapConfigToSchema({ config, baseFieldsTemplate });
        // all columns in csv are expected to exist
        required.push(field);
        properties[field] = propSchema;
    }
    // build row schema
    const rowSchema = {
        type: 'object',
        properties,
        additionalProperties: false,
    };
    if (required.length) {
        rowSchema.required = required;
    }
    // build the finley_array schema
    const jsonSchema = {
        $schema: 'http://json-schema.org/draft-07/schema#',
        type: 'object',
        properties: {
            finley_array: {
                type: 'array',
                items: rowSchema,
            },
        },
        required: ['finley_array'],
    };
    return jsonSchema;
};
exports.baseFieldsToFinleyArrayJsonSchema = baseFieldsToFinleyArrayJsonSchema;
const validateConfig = (_transformation) => {
    const errors = [];
    // currently nothing to validate here
    return errors;
};
const getOutputDataTapeValues = (transformation) => {
    const errors = validateConfig(transformation);
    if (errors.length) {
        return { isValid: false, errors };
    }
    let baseFields;
    if (transformation.fields) {
        baseFields = transformation.fields;
    }
    else if (transformation.baseFieldsTemplate) {
        switch (transformation.baseFieldsTemplate) {
            case 'balanceSheet':
            case 'incomeStatement':
                baseFields = exports.FINANCIAL_STATEMENT_BASE_FIELDS;
                break;
            default:
                throw (0, common_1.finleyAssertUnreachable)(transformation.baseFieldsTemplate);
        }
    }
    else {
        (0, common_1.finleyAssert)(transformation.srcDataTape, 'Ai2Csv: source data tape fields must be defined if configuration.fields is not defined.');
        baseFields = transformation.srcDataTape.baseFields;
    }
    // output tape definition is decided by sanitize.
    // lets call sanitize helper to get the output tape definition.
    const sanitizeTransformation = {
        operation: 'sanitize',
        srcDataTape: {
            baseFields,
            delimiter: ',',
        },
        // Note:we do not want to sanitize field names
        // to give flexibility to user to decorate them with special characters.
        // if they wanted sanitized names, they can always specify fields names as such.
        sanitizeFieldNames: false,
    };
    const data = (0, helpers_1.getSanitizeTransformOpOutputDataTape)(sanitizeTransformation);
    return { isValid: true, data };
};
const validateTransform = (transformation) => {
    try {
        const res = getOutputDataTapeValues(transformation);
        return res;
    }
    catch (error) {
        const errors = [];
        errors.push({
            type: 'metadataValidation',
            message: error instanceof Error
                ? error.message
                : 'Unexpected Error in ai2Csv:getOutputDataTape',
        });
        return { isValid: false, errors };
    }
};
exports.validateTransform = validateTransform;
const performTransform = async ({ transformation, csvParser, ai2CsvExtractor, }) => {
    try {
        const validationResult = validateConfig(transformation);
        (0, common_1.finleyAssert)(validationResult.length === 0, `Invalid transformation params: [${validationResult.join(', ')}]`);
        const { prompt, fields, baseFieldsTemplate } = transformation;
        let baseFields;
        if (fields) {
            baseFields = fields;
        }
        else if (baseFieldsTemplate) {
            switch (baseFieldsTemplate) {
                case 'balanceSheet':
                case 'incomeStatement':
                    baseFields = exports.FINANCIAL_STATEMENT_BASE_FIELDS;
                    break;
                default:
                    throw (0, common_1.finleyAssertUnreachable)(baseFieldsTemplate);
            }
        }
        else {
            (0, common_1.finleyAssert)(transformation.srcDataTape, 'Ai2Csv: source data tape fields must be defined if configuration.fields is not defined.');
            baseFields = transformation.srcDataTape.baseFields;
        }
        const extractedCsvResult = await ai2CsvExtractor({
            prompt,
            baseFields,
            extractionConfigs: transformation.documents,
            baseFieldsTemplate,
        });
        if (!extractedCsvResult.isValid) {
            return extractedCsvResult;
        }
        const sanitizedCsvResult = await sanitizeTransform.transformOperation.performTransform({
            dataTapeBuffers: [extractedCsvResult.data.outputBuffer],
            transformation: {
                operation: 'sanitize',
                sanitizeFieldNames: false,
                srcDataTape: {
                    baseFields,
                    delimiter: ',',
                },
            },
            csvParser,
        });
        return sanitizedCsvResult;
    }
    catch (error) {
        return (0, errorUtils_1.convertErrorToTapeFailureResult)(error, 'ai2Csv: ');
    }
};
exports.performTransform = performTransform;
exports.transformOperation = {
    operation: 'ai2Csv',
    validateTransform: exports.validateTransform,
    performTransform: exports.performTransform,
};
//# sourceMappingURL=ai2csv-transform.js.map